module.exports = __webpack_public_path__ + "src/assets/img/btn1.7ebff8be.png";